import { useGetBusinessSettingsQuery } from './__generated__/graphql';

export const useBusinessSettings = () => {
  const { data } = useGetBusinessSettingsQuery();
  return data?.getBusiness;
};
